function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettingsTemplate = require('./archive-settings.template');
var ArchiveSettings = /*#__PURE__*/function () {
  function ArchiveSettings(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-module-settings';
    _classCallCheck(this, ArchiveSettings);
    this.app = app;
    this.mod = mod;
    this.container = container;
  }
  return _createClass(ArchiveSettings, [{
    key: "render",
    value: function render() {
      this.app.browser.addElementToSelector(SettingsTemplate(this.app, this.mod), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var input = document.getElementById('archive-prune-public-days');
      if (!input) {
        return;
      }
      input.addEventListener('change', function () {
        var days = Number(input.value);
        if (!Number.isInteger(days) || days < 1) {
          input.value = String(_this.mod.returnPrunePublicDays());
          return;
        }
        _this.mod.setPrunePublicDays(days);
      });
    }
  }]);
}();
module.exports = ArchiveSettings;